import * as React from 'react';
import { sendUserToFrelsiPayment, isValidPackage, FrelsiResponse } from '@/components/Frelsi/Utils';
import Button from 'components/src/button';
import { getOr } from '@/utils/options';
import { NextRouter, useRouter } from 'next/router';
import { MobilePackageType } from '../Frelsi/Types';
import { Subheading } from 'components/src/typography';

type Props = {
  currentUrl: string;
  phoneNumber: string | null;
  mobilePackage: MobilePackageType | null;
  setFrelsiResponse: React.Dispatch<React.SetStateAction<FrelsiResponse | null>>;
  frelsiResponse: FrelsiResponse | null;
};

const DefaultState = ({
  isLoading,
  setIsLoading,
  setFrelsiResponse,
  phoneNumber,
  currentUrl,
  mobilePackage,
  router,
}: {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setFrelsiResponse: React.Dispatch<React.SetStateAction<FrelsiResponse | null>>;
  phoneNumber: string | null;
  currentUrl: string;
  mobilePackage: MobilePackageType | null;
  router: NextRouter;
}) => {
  return (
    <>
      <Button
        label={'Kaupa'}
        variant="primary"
        autoWidth={false}
        classes="h-[76px]"
        loading={isLoading}
        onClick={() => {
          setIsLoading(true);
          isValidPackage(
            getOr(phoneNumber, ''),
            getOr(mobilePackage?.id, 0),
            getOr(mobilePackage?.price, 0),
            setFrelsiResponse,
            setIsLoading,
            (): Promise<void> => {
              //Send in price to validate
              return sendUserToFrelsiPayment(
                router,
                phoneNumber,
                currentUrl,
                mobilePackage?.id,
                setIsLoading,
                getOr(mobilePackage?.id, 0),
                getOr(mobilePackage?.price, 0)
              );
            }
          );
        }}
        disabled={phoneNumber ? phoneNumber.length <= 6 : true}
      />
      {/* 
      <Button
        label={'Kaupa'}
        variant="primary"
        autoWidth={false}
        classes="h-[76px]"
        loading={isLoading}
        onClick={() => {
          setIsLoading(true);
          isValidPackage(
            getOr(phoneNumber, ''),
            getOr(mobilePackage?.id, 0),
            getOr(mobilePackage?.price, 0),
            setFrelsiResponse,
            setIsLoading,
            (): Promise<void> => {
              //Send in price to validate
              return sendUserToStraumurPayment(
                router,
                phoneNumber,
                currentUrl,
                setIsLoading,
                getOr(mobilePackage?.id, 0),
                getOr(mobilePackage?.price, 0)
              );
            }
          );
        }}
        disabled={phoneNumber ? phoneNumber.length <= 6 : true}
      />
      */}
    </>
  );
};

const FooterSection = ({ currentUrl, phoneNumber, mobilePackage, setFrelsiResponse, frelsiResponse }: Props) => {
  const router = useRouter();
  const [isLoading, setIsLoading] = React.useState(false);

  if (frelsiResponse === 'notPrepaid') {
    return (
      <Subheading small classes="text-black-50">
        {'Ekki frelsisnúmer'}
      </Subheading>
    );
  } else if (frelsiResponse === 'notVodafone') {
    return (
      <Subheading small classes="text-red-100">
        {'Ekki sýn númer'}
      </Subheading>
    );
  } else if (frelsiResponse === 'invalidPackage') {
    return (
      <Subheading small classes="text-red-100">
        {'Ekki er hægt að virkja þennan pakka á þetta símanúmer'}
      </Subheading>
    );
  } else if (frelsiResponse === 'error' || frelsiResponse === 'noReferenceNumber') {
    return (
      <Subheading small classes="text-red-100">
        {'Villa kom upp við áfyllingu, reyndu aftur síðar'}
      </Subheading>
    );
  }
  return (
    <DefaultState
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      setFrelsiResponse={setFrelsiResponse}
      phoneNumber={phoneNumber}
      currentUrl={currentUrl}
      mobilePackage={mobilePackage}
      router={router}
    />
  );
};
export default FooterSection;
